import { Box, Typography, IconButton, Modal } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import VisibilityIcon from "@mui/icons-material/Visibility";
import React, { useRef, useState } from "react";
import { UploadFileService } from "../../services/shared/UploadFileService";
import ApiUrl from "../../services/shared/ApiUrl";

interface MuiUploadImageProps {
  label: string;
  name: string;
  values: string;
  errors: string;
  onFileUpload?: (fileUrl: string | null) => void;
  isRequired?: boolean;
}

const MuiUploader: React.FC<MuiUploadImageProps> = ({
  label,
  name,
  values,
  errors,
  onFileUpload,
  isRequired = false,
}) => {
  const [fileName, setFileName] = useState<string | null>(null);
  const [uploadedUrl, setUploadedUrl] = useState<string | null>(values);
  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const inputFile = useRef<HTMLInputElement>(null);

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setFileName(file.name);
      uploadFile(file);
    }
  };

  const uploadFile = async (file: File) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const imageUrlData = await UploadFileService.getImagePath(formData);

      const uploadedImageUrl = imageUrlData.data.fileName;

      setUploadedUrl(uploadedImageUrl);
      if (onFileUpload) onFileUpload(uploadedImageUrl);
    } catch (error) {
      console.error("File upload failed", error);
    }
  };

  const handleOpenPreview = () => setPreviewModalOpen(true);
  const handleClosePreview = () => setPreviewModalOpen(false);

  return (
    <>
      <Box position="relative" width="100%">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          border={`1px solid ${errors ? "#d32f2f" : "#ccc"}`}
          borderRadius="5px"
          p={1}
          width="100%"
        >
          <Typography variant="body2" component="label" htmlFor={name}>
            {fileName || (
              <>
                Upload {label}
                {isRequired && (
                  <Typography
                    component="span"
                    color={"#d32f2f"}
                    fontWeight="bold"
                    ml={0.5}
                  >
                    *
                  </Typography>
                )}
              </>
            )}
          </Typography>

          <input
            type="file"
            id={name}
            ref={inputFile}
            style={{ display: "none" }}
            accept="image/*"
            onChange={handleFileChange}
            aria-required={isRequired}
          />
          <IconButton
            color="primary"
            component="label"
            onClick={() => inputFile.current?.click()}
          >
            <CloudUploadIcon />
          </IconButton>

          {uploadedUrl && (
            <IconButton color="primary" onClick={handleOpenPreview}>
              <VisibilityIcon />
            </IconButton>
          )}
        </Box>

        {errors && (
          <Typography
            color="#d32f2f"
            variant="body2"
            sx={{
              position: "absolute",
              top: "100%",
              left: 0,
              fontSize: "12px",
            }}
          >
            {errors}
          </Typography>
        )}
      </Box>

      {/* {errors && (
        <Typography color="error" className="err-msg" variant="body2" mt={1}>
          {errors}
        </Typography>
      )} */}

      {/* Preview Modal */}
      <Modal
        open={previewModalOpen}
        onClose={handleClosePreview}
        aria-labelledby="image-preview-modal"
        aria-describedby="Preview uploaded image"
      >
        <Box
          position="absolute"
          top="50%"
          left="50%"
          style={{ transform: "translate(-50%, -50%)" }}
          bgcolor="background.paper"
          boxShadow={24}
          p={2}
          borderRadius="8px"
          maxWidth="90%"
          maxHeight="90%"
        >
          {uploadedUrl && (
            <img
              src={`${ApiUrl.fileBaseUrl}${uploadedUrl}`}
              alt="Preview"
              style={{ maxWidth: "100%", maxHeight: "80vh" }}
            />
          )}
        </Box>
      </Modal>
    </>
  );
};

export default MuiUploader;
